import styled from 'styled-components';

export const TariffsListStyled = styled.div`
	gap: 16px;
	display: flex;
	flex-direction: column;
`;

export const TariffsDetailsContainerStyled = styled.div`
	scroll-margin-top: 75px;
	margin-top: 48px;
`;
